const TailoredCarePlansIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M48.897 64H14.8962C11.645 64 9 61.355 9 58.1039V5.89612C9 2.64495 11.645 0 14.8962 0H42.7932C43.3264 0 43.7587 0.432232 43.7587 0.965488C43.7587 1.49874 43.3264 1.93098 42.7932 1.93098H14.8962C12.7098 1.93098 10.9311 3.70974 10.9311 5.89612V58.1039C10.9311 60.2903 12.7098 62.069 14.8962 62.069H48.897C51.0834 62.069 52.8621 60.2903 52.8621 58.1039V12C52.8621 11.4667 53.2944 11.0345 53.8277 11.0345C54.3609 11.0345 54.7932 11.4667 54.7932 12V58.1039C54.7932 61.355 52.1482 64 48.897 64Z"
        fill="#027C80"
      />
      <path
        d="M53.8277 12.9655H45.6211C43.5294 12.9655 41.8276 11.2638 41.8276 9.17206V0.965489C41.8276 0.574938 42.0629 0.222926 42.4237 0.073486C42.7845 -0.0758796 43.1998 0.00666062 43.4759 0.282792L54.5104 11.3173C54.7865 11.5934 54.8691 12.0087 54.7197 12.3695C54.5702 12.7303 54.2182 12.9655 53.8277 12.9655ZM43.7587 3.29644V9.17206C43.7587 10.199 44.5942 11.0345 45.6211 11.0345H51.4967L43.7587 3.29644Z"
        fill="#027C80"
      />
      <path
        d="M20.2671 18.3475C19.9885 18.3475 19.7271 18.2466 19.5231 18.061C19.2752 17.8353 17.0612 15.8205 15.5212 14.4596C13.5172 12.6886 13.3494 11.0852 13.3494 9.72134C13.3494 7.74375 14.89 5.60938 17.3789 5.60938C18.755 5.60938 19.7139 6.18229 20.3166 6.73059C20.9303 6.18783 21.9008 5.62531 23.2869 5.62531C25.7959 5.62531 27.349 7.75669 27.349 9.73152C27.349 11.095 27.1793 12.6977 25.1531 14.4662C23.646 15.7816 21.4216 17.708 20.991 18.0808C20.8038 18.243 20.5637 18.3375 20.3154 18.3465L20.3084 18.3468C20.2946 18.3472 20.2808 18.3475 20.2671 18.3475ZM17.3789 7.54035C15.8088 7.54035 15.2804 9.03812 15.2804 9.72134C15.2804 10.8253 15.3923 11.7687 16.7999 13.0126C17.9503 14.0292 19.4715 15.4057 20.2814 16.1407C21.1461 15.3915 22.7268 14.0208 23.8833 13.0114C25.305 11.7706 25.418 10.831 25.418 9.73152C25.418 9.0501 24.8813 7.55629 23.2869 7.55629C21.8824 7.55629 21.2363 8.55471 21.1673 8.6686C20.9347 9.05099 20.4717 9.23598 20.0409 9.11917C20.0406 9.11909 20.0404 9.11902 20.0402 9.11902C19.7823 9.04897 19.5593 8.87529 19.4282 8.64233C19.3647 8.52926 18.7687 7.54035 17.3789 7.54035Z"
        fill="#FFA473"
      />
      <path
        d="M28.3104 25.1029H13.6896C13.1564 25.1029 12.7241 24.6706 12.7241 24.1374C12.7241 23.6041 13.1564 23.1719 13.6896 23.1719H28.3104C28.8436 23.1719 29.2759 23.6041 29.2759 24.1374C29.2759 24.6706 28.8436 25.1029 28.3104 25.1029Z"
        fill="#06AEB3"
      />
      <path
        d="M42.7931 31.4466H21.2758C20.7426 31.4466 20.3103 31.0144 20.3103 30.4811C20.3103 29.9479 20.7426 29.5156 21.2758 29.5156H42.7931C43.3264 29.5156 43.7586 29.9479 43.7586 30.4811C43.7586 31.0144 43.3264 31.4466 42.7931 31.4466Z"
        fill="#06AEB3"
      />
      <path
        d="M42.7931 35.7279H21.2758C20.7426 35.7279 20.3103 35.2956 20.3103 34.7624C20.3103 34.2291 20.7426 33.7969 21.2758 33.7969H42.7931C43.3264 33.7969 43.7586 34.2291 43.7586 34.7624C43.7586 35.2956 43.3264 35.7279 42.7931 35.7279Z"
        fill="#06AEB3"
      />
      <path
        d="M42.7931 40.0013H21.2758C20.7426 40.0013 20.3103 39.5691 20.3103 39.0358C20.3103 38.5025 20.7426 38.0703 21.2758 38.0703H42.7931C43.3264 38.0703 43.7586 38.5025 43.7586 39.0358C43.7586 39.5691 43.3264 40.0013 42.7931 40.0013Z"
        fill="#06AEB3"
      />
      <path
        d="M42.7931 44.2747H21.2758C20.7426 44.2747 20.3103 43.8425 20.3103 43.3092C20.3103 42.776 20.7426 42.3438 21.2758 42.3438H42.7931C43.3264 42.3438 43.7586 42.776 43.7586 43.3092C43.7586 43.8425 43.3264 44.2747 42.7931 44.2747Z"
        fill="#06AEB3"
      />
      <path
        d="M42.7931 48.5482H21.2758C20.7426 48.5482 20.3103 48.1159 20.3103 47.5827C20.3103 47.0494 20.7426 46.6172 21.2758 46.6172H42.7931C43.3264 46.6172 43.7586 47.0494 43.7586 47.5827C43.7586 48.1159 43.3264 48.5482 42.7931 48.5482Z"
        fill="#06AEB3"
      />
      <path
        d="M50.1036 55.8607H35.4829C34.9496 55.8607 34.5173 55.4284 34.5173 54.8952C34.5173 54.3619 34.9496 53.9297 35.4829 53.9297H50.1036C50.6368 53.9297 51.0691 54.3619 51.0691 54.8952C51.0691 55.4284 50.6368 55.8607 50.1036 55.8607Z"
        fill="#06AEB3"
      />
    </svg>
  );
};

export default TailoredCarePlansIcon;
